module.exports = function() {
  return new Worker(__webpack_public_path__ + "cab91ffecc066e99500b.worker.js");
};